import { useCallback, useState } from 'react';

export enum StorageType {
	LOCAL_STORAGE = 'localStorage',
	SESSION_STORAGE = 'sessionStorage'
}

const usePersistedState = <Type>(
	storageKey: string,
	storageType: StorageType,
	fallbackValue?: Type
): [Type | undefined, (value: Type) => void] => {
	const [current, setCurrent] = useState(() => {
		if (window[storageType]) {
			const stored = window[storageType].getItem(storageKey);
			if (stored) return JSON.parse(stored) as Type;
		}

		return fallbackValue;
	});

	const setValue = useCallback(
		(newValue: Type) => {
			if (window[storageType]) {
				const stringifiedValue = JSON.stringify(newValue);
				if (stringifiedValue) window[storageType].setItem(storageKey, stringifiedValue);
				else window[storageType].removeItem(storageKey);
			}

			setCurrent(newValue);
		},
		[storageKey, storageType]
	);

	return [current, setValue];
};

export default usePersistedState;
